import React from 'react';
import { BrowserRouter } from 'react-router-dom';
// Routes
import { Provider } from 'react-redux';
import { SkeletonTheme } from 'react-loading-skeleton';
import AppRoutes from './Routes';
// Redux
import reduxStore from './redux/store/redux';
// Google Material
import configureTheme from './utilities/configureTheme';
import { CircularProgress, createTheme, ThemeProvider } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import AuthGate from './auth/AuthGate';
import SetActiveAccount from './auth/SetActiveAccount';
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      theme: null,
      clientId: null,
      loading: true,
    };
  }

  componentDidMount() {
    const id = new URLSearchParams(window.location.search).get('id');
    const clientId = new URLSearchParams(window.location.search).get('clientid');
    if (id) {
      this.setState({ clientId: id });
    } else {
      this.setState({ clientId: clientId });
    }

    // Loading Redux
    window.reduxStore = reduxStore;
    window.clientId = clientId;

    // Set theme
    const themeOptions = configureTheme();
    this.setState({ theme: createTheme(themeOptions) });
    this.setState({ loading: false });

  }

  render() {
    return (
      <AuthGate>
        <SetActiveAccount/>
        <div id="content">
        <div id="scrollContainer">
          {this.state.loading && <CircularProgress />}
          {this.state.theme && (
            <ThemeProvider theme={this.state.theme}>
              <Provider store={reduxStore}>
                <BrowserRouter>
                      <SkeletonTheme baseColor="#d9dadb" highlightColor="#e8e9e9">
                        <AppRoutes clientId={this.state.clientId} />
                      </SkeletonTheme>
                </BrowserRouter>
              </Provider>
            </ThemeProvider>
          )}
        </div>
        <ToastContainer />
      </div>
      </AuthGate>

    );
  }
}

export default App;
